import { currentAppBrand } from '../current-brand'
import { featuresForCurrentBrand } from '../features'

/**
 * Retourne le thème CSS à appliquer en fonction du partenaire de l'utilisateur.
 * Si le partenaire a un thème spécifique configuré dans `partnerThemesList`, celui-ci est retourné.
 * Sinon, le thème par défaut de la marque est utilisé.
 *
 * @param options - Options de configuration
 * @param options.partnerId - Identifiant du partenaire (coopérative) de l'utilisateur
 * @returns Le nom du thème à appliquer (ex: 'soufflet-vigne', 'farmi', 'aladin')
 */
export function getTheme(options?: { partnerId?: string | number }): string {
  const { currentTheme } = featuresForCurrentBrand.server
  const { canBeChangeAtRuntime, partnerThemesList } = currentTheme

  if (canBeChangeAtRuntime && options?.partnerId) {
    const key = String(options.partnerId)
    const partnerTheme = partnerThemesList?.get(key)
    if (partnerTheme) return partnerTheme
  }

  return currentAppBrand
}
